import Vue from 'vue'
import Router from 'vue-router'

import _ from 'lodash'

import store, { setApplicationModule } from '@/store'

import { identify } from '@/repository/identity'
import { isRouteMatch } from '@/util'

import generalRoutes from '@/routes/general-routes'
import identityRoutes from '@/routes/identity-routes'
import adminRoutes from '@/routes/admin-routes'
import reportRoutes from '@/routes/report-routes'
import productRoutes from '@/routes/product-routes'
import salesPointRoutes from '@/routes/sales-point-routes'

import { PERMISSION_DENIED } from '@/routes/general'
import { SIGNIN } from '@/routes/identity'

import { i18n, loadLanguage } from '@/i18n'

Vue.use(Router)

const router = new Router({
  routes: _.concat(
    generalRoutes, identityRoutes, adminRoutes, salesPointRoutes, productRoutes, reportRoutes,
    { path: '*', redirect: '/' })
})

router.beforeEach(ensureCurrentUser)
router.beforeEach(ensureApplicationModule)
router.afterEach(ensureTitle)

function ensureCurrentUser (to, from, next) {
  identify(store)
    .then(user => {
      if (user.locale) {
        return loadLanguage(user.locale)
          .then(() => nextWithUser(to, next, user))
      } else {
        nextWithUser(to, next, user)
      }
    })
    .catch(() => {
      nextWithUser(to, next)
    })
}
function ensureApplicationModule (to, from, next) {
  const modules = store.state.identity.capabilities && store.state.identity.capabilities.modules
  if (!_.isEmpty(modules)) {
    const route = findRoot(to)
    if (route) {
      setApplicationModule(store, _.find(modules, c => c.route && c.root === route.meta.root))
    } else {
      setApplicationModule(store, undefined)
    }
  }
  next()
}

function ensureTitle (to) {
  const generalTitle = i18n.t(store.state.environment.current.appTitleKey)
  const titleKey = to.meta && to.meta.titleKey
  document.title = titleKey ? `${i18n.t(titleKey)} | ${generalTitle}` : generalTitle
}

function nextWithUser (to, next, user) {
  const authorize = !to.meta || !to.meta.public

  if (!user && authorize) {
    next({ name: SIGNIN })
  } else {
    if (user && authorize && !user.hasAnyPermission(to.meta.permissions)) {
      next({ name: PERMISSION_DENIED })
    } else {
      next()
    }
  }
}

function findRecursive (name, route) {
  if (isRouteMatch(name, route)) {
    return route
  } else {
    return _.find(_.map(route.children, c => findRecursive(name, c)))
  }
}

export const findRoute = (name) => {
  return router && _.find(_.map(router.options.routes, r => findRecursive(name, r)))
}

export const isRouteActive = (route) => {
  return !!route && _.some(router.currentRoute.matched, r => isRouteMatch(route, r))
}

export const findRoot = (route) => {
  return _.find(route.matched || [route], r => r.meta && r.meta.root)
}

export default router
